import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, useTheme } from '@material-ui/core/styles';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import NicheColorLegend from 'components/ProgramGridByNiche/NicheColorLegend';
import NicheIllustration from 'components/ProgramGridByNiche/NicheIllustration';
import { getNicheVisualTheme } from 'components/ProgramGridByNiche/nicheVisualTheme';
import {
  programGridByNiche,
  countActivePrograms,
} from '../../TNOBusinessLevel/businessLevelPresentationData';

const PREVIEW_NICHES = programGridByNiche.slice(0, 4);

const ProgramacionTeaser = () => {
  const theme = useTheme();
  const programCount = countActivePrograms();
  const allNicheNames = programGridByNiche.map((g) => g.niche);
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary?.main || '#00838f';

  return (
    <Box
      sx={{
        borderRadius: 4,
        overflow: 'hidden',
        background: `linear-gradient(165deg, ${alpha(primary, 0.05)} 0%, ${alpha(secondary, 0.08)} 45%, transparent 100%)`,
        px: { xs: 1, md: 2 },
        py: { xs: 3, md: 4 },
      }}
    >
      <Box marginBottom={3} textAlign="center">
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 2 }} gutterBottom color="secondary">
          Parrilla TNO Network
        </Typography>
        <Box component={Typography} fontWeight={900} variant="h4" gutterBottom color="primary">
          Programación por nichos
        </Box>
        <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 640, mx: 'auto', mb: 3 }}>
          Más de {programCount} producciones organizadas por vertical temática — cada bloque tiene color e ilustración propia
          para ubicar tu marca con contexto.
        </Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 3, maxWidth: 960, mx: 'auto' }}>
        {PREVIEW_NICHES.map((group) => {
          const visual = getNicheVisualTheme(group.niche);
          const count = group.programs?.length || 0;
          return (
            <Grid item xs={6} md={3} key={group.niche}>
              <Box
                sx={{
                  borderRadius: 3,
                  overflow: 'hidden',
                  height: '100%',
                  boxShadow: `0 10px 28px ${alpha(visual.main, 0.15)}`,
                  border: `1px solid ${alpha(visual.main, 0.2)}`,
                }}
              >
                <Box
                  sx={{
                    background: visual.gradient,
                    px: 1.5,
                    py: 1.25,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 72,
                  }}
                >
                  <NicheIllustration type={visual.illustration} width={52} color="#fff" />
                  <Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: '0.68rem',
                      color: '#fff',
                      textAlign: 'right',
                      lineHeight: 1.2,
                      maxWidth: '58%',
                    }}
                  >
                    {group.niche}
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: visual.light, px: 1.5, py: 1.25 }}>
                  <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, color: visual.main }}>
                    {count} {count === 1 ? 'producción' : 'producciones'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ maxWidth: 920, mx: 'auto', mb: 3 }}>
        <NicheColorLegend
          niches={allNicheNames}
          caption="Verticales de la grilla"
          size="small"
        />
      </Box>

      <Box textAlign="center">
        <Button
          component={RouterLink}
          to="/programacion"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<LiveTvIcon />}
          endIcon={<ArrowForwardIcon />}
          sx={{ borderRadius: 999, px: 3 }}
        >
          Ver grilla completa
        </Button>
      </Box>
    </Box>
  );
};

export default ProgramacionTeaser;
